// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__218sU","toggle":"styles_toggle__1kjSH","preview":"styles_preview__qrpr8"};